import React from 'react';
import { ResetPasswordCompleteForm } from './components/ResetPasswordCompleteForm/ResetPasswordCompleteForm';
import { ResetPasswordForm } from './components/ResetPasswordForm/ResetPasswordForm';
import { useViewModel } from './hook/use-view-model';
import { ResetPasswordBlockProps } from './type/props';

export const ResetPasswordBlock = (props: ResetPasswordBlockProps) => {
  const { passwordResetSubmitHandler, showComplete, phone, isLoading } = useViewModel();

  if (showComplete) {
    return <ResetPasswordCompleteForm onSuccess={props.onSuccess} phone={phone} />;
  }

  return <ResetPasswordForm onPasswordReset={passwordResetSubmitHandler} isLoading={isLoading} />;
};
